import { Alert } from "antd";
import { FailedAttachment } from "../../utils/reporting/reportFiles";

type FailedAttachmentsNoticeProps = {
	attachments: FailedAttachment[];
};

/**
 * Informational banner for attachments the last sync could not store in
 * SharePoint. The user clears an entry through the upload field's own delete
 * control and attaches the file again; nothing is removed automatically.
 */
const FailedAttachmentsNotice = ({
	attachments,
}: FailedAttachmentsNoticeProps) => {
	if (attachments.length === 0) return null;

	return (
		<div className="px-8 pt-3">
			<Alert
				type="warning"
				showIcon
				message="Some attachments are not stored in SharePoint"
				description={
					<div className="flex flex-col gap-1">
						<span>
							Saving the report retries the upload. If a file cannot be retried,
							remove it from the report and attach it again.
						</span>
						<ul className="list-disc pl-5 m-0">
							{attachments.map((attachment) => (
								<li key={`${attachment.location}-${attachment.uid}`}>
									<strong>{attachment.fileName}</strong> ({attachment.location}
									): {attachment.userMessage}
								</li>
							))}
						</ul>
					</div>
				}
			/>
		</div>
	);
};

export default FailedAttachmentsNotice;
